import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RetailDetailAPIResponse } from 'src/app/models/product-list';
import { HelperService } from '../helper/helper.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class RetailDetailService {
  apiParams: any;

  public get retailDetailServiceApi(): string {
    // tslint:disable-next-line: max-line-length
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    return this.retailDetailServiceApi = `${this.envService.getRetailersDetailsV2Api()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  public set retailDetailServiceApi(value: string) {
  }

  constructor(private httpClient: HttpClient, private helperService: HelperService, private envService: EnvironmentConfigService) {
    this.initApiParams();
  }

  initApiParams() {
    this.apiParams = {
      page: 1,
      perpage: 10,
      location: '',
      storeId: '',
      showcoupon: 1
    };
  }

  getRetailerDetailsByStoreId(storeId: number, page: number, location: number, prefix: string): Observable<RetailDetailAPIResponse> {
    this.apiParams.storeId = storeId;
    this.apiParams.page = page;
    this.apiParams.locationid = location;
    this.apiParams.prefix = prefix || '';
    const guestId = localStorage.getItem('guestId');
    if (guestId != null) {
      this.apiParams.guestid = guestId;
    }
    return this.httpClient.get<RetailDetailAPIResponse>(this.retailDetailServiceApi);
  }

}
